import $ from "jquery";
import React, { Suspense, useContext, useEffect, useState } from 'react';
import OrderSummary from "./OrderSummary";
import VoucherSummary from './VoucherSummary';
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";



const Reports = () => {

    const companyInfo = useContext(UserBasicInfoQRContext);

    const [currentTab, setCurrentTab] = useState("order-summary");
    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }




    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20">

            {(companyInfo?.id === null || companyInfo?.id === "" || companyInfo?.id === undefined) ?
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                Before proceeding, please select a company.
                            </td>
                        </tr>
                    </tbody>
                </table>
                :
                <>

                    <div className="tab ">
                        <button className="tablinks current" onClick={(event) => handleTab("order-summary", event)}>Shop History</button>
                        <button className="tablinks" onClick={(event) => handleTab("voucher-summary", event)}>Voucher History</button>
                    </div>


                    <div className='tabcontentbody py-3 px-0'>
                        <div id="view-profile" className="tabcontent" style={{ display: "block", paddingInline: "0px" }}>
                            <Suspense fallback="Loading...">
                                {(() => {
                                    switch (currentTab) {
                                        case "order-summary":
                                            return <OrderSummary />;
                                        case "voucher-summary":
                                            return <VoucherSummary />;
                                        default:
                                            return <h1>No page found.</h1>;
                                    }
                                })()}
                            </Suspense>
                        </div>
                    </div>
                </>
            }

        </div>
    )
}


export default Reports;
